<ng-container *ngIf="counts">
  <div
    *ngIf="!hidePotentialInviteeCount && (showPotentialInviteeCount$ | async)"
    class="count-item potential-invitee-count-item"
    [matTooltip]="'potentialInviteeCount' | i18n | titlecase"
    matTooltipPosition="above">
    <mat-icon
      svgIcon="person_check"
      class="size-20 count-icon potential-invitee-count-icon"
      [class.inactive]="counts.potentialInviteeCount === 0"></mat-icon>
    <div
      class="count-number"
      data-cy="job-list-item-potential-invitee-count">
      {{ counts.potentialInviteeCount }}
    </div>
  </div>
  <div
    class="count-item"
    [class.inactive]="counts.open === 0"
    [matTooltip]="'waiting' | i18n | titlecase"
    matTooltipPosition="above">
    <mat-icon
      svgIcon="waiting-clock-circle-filled"
      class="size-16 count-icon pending-icon"></mat-icon>
    <div
      class="count-number"
      data-cy="job-list-item-pending-count">
      {{ counts.open }}
    </div>
  </div>
  <div
    class="count-item"
    [class.inactive]="counts.unavailable === 0"
    [matTooltip]="'declined' | i18n | titlecase"
    matTooltipPosition="above">
    <mat-icon
      svgIcon="not-available-busy-circle-filled"
      class="size-16 count-icon not-available-icon"></mat-icon>
    <div
      class="count-number"
      data-cy="job-list-item-unavailable-count">
      {{ counts.unavailable }}
    </div>
  </div>
  <div
    class="count-item"
    [class.inactive]="counts.available === 0"
    [matTooltip]="'available' | i18n | titlecase"
    matTooltipPosition="above">
    <mat-icon
      svgIcon="available-check-circle-filled"
      class="size-16 count-icon available-icon"></mat-icon>
    <div
      class="count-number"
      data-cy="job-list-item-available-count">
      {{ counts.available }}
    </div>
  </div>
  <div
    class="count-item"
    [class.inactive]="counts.booked === 0"
    [matTooltip]="'booked' | i18n | titlecase"
    matTooltipPosition="above">
    <mat-icon
      svgIcon="booked-star-circle-filled"
      class="size-16 count-icon booked-icon"></mat-icon>
    <div
      class="count-number"
      data-cy="job-list-item-booked-count">
      {{ counts.booked }} /
      {{ counts.requiredUsers }}
    </div>
  </div>
</ng-container>
